import { connect } from 'react-redux'
import { reduxForm, formValueSelector } from 'redux-form'
import Form from '../Components/Form'

import validate from './validate'
import onSubmit from './onSubmit'
import onSubmitFail from './onSubmitFail'

export const FORM_NAME = 'SubOrder'

const formConfig = {
  form: FORM_NAME,
  validate,
  onSubmit,
  onSubmitFail,
}

const selector = formValueSelector(FORM_NAME)

const mapStateToProps = (state, ownProps) => {
  console.log('Form mapStateToProps - ownProps:', ownProps)
  return {
    projectId: selector(state, 'project_id'),
    statusKey: selector(state, 'status_key'),
    setPercentage: selector(state, 'set_percentage'),
    setAmount: selector(state, 'set_amount'),
    orderTotal: ownProps.orderTotal,
  }
}

export default connect(mapStateToProps)(reduxForm(formConfig)(Form))
